module.exports = __webpack_public_path__ + "static/img/side_logo_max.290273f8.png";